import React from 'react'
import ProductItem from './item'
import styles from '../index.less'
import { isOdd } from '../utils'
import { ITEM_SCROLL_TIME, ITEM_TRANSITION_TIMING, LOOP_SLIDERS } from '../config'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SwiperOptions } from 'swiper/types/swiper-options'
import 'swiper/swiper.min.css'

interface IProps {
  CName: string
  uid: string
  componentIndex: number
  pageId: string
  needScene?: boolean
  componentStyle?: number
  groups: any[][]
  outputBusiness: any
}
const ProductTwoLine = (props: IProps) => {
  const { needScene, groups, CName, uid, pageId, outputBusiness } = props

  const initStyle = (swiper) => {
    // console.log('twoline initStyle swiper: ', swiper)
    // swiper.autoplay.stop()
    const imgBoxes = Array.from(swiper.wrapperEl.children || []) as HTMLDivElement[]
    const activeIndex = swiper.activeIndex
    const isCurrentOdd = isOdd(activeIndex) // 判断当前位置是不是奇数
    const currentViewRectIndexList = new Array(LOOP_SLIDERS)
      .fill(activeIndex)
      .map((_, i) => activeIndex + i)
    imgBoxes.length &&
      imgBoxes.forEach((node, index) => {
        const [child1, child2] = Array.from(node.children) as HTMLDivElement[]
        // console.log('initStyle: ', isCurrentOdd, index, imgBoxes.length, { ...swiper })
        /**
         * 此处处理逻辑：
         * 如果当前是奇数列，则所有奇数列中第 0 项及 child1 为 big，第 1 项及 child2 为 small
         */
        if (currentViewRectIndexList.includes(index)) {
          if (isOdd(index)) {
            // 第index列
            if (isCurrentOdd) {
              child1 && child1.classList.add(styles.big)
              child1 && child1.classList.remove(styles.small)
              child2 && child2.classList.add(styles.small)
              child2 && child2.classList.remove(styles.big)
            } else {
              child1 && child1.classList.add(styles.small)
              child1 && child1.classList.remove(styles.big)
              child2 && child2.classList.add(styles.big)
              child2 && child2.classList.remove(styles.small)
            }
          } else {
            if (isCurrentOdd) {
              child1 && child1.classList.add(styles.small)
              child1 && child1.classList.remove(styles.big)
              child2 && child2.classList.add(styles.big)
              child2 && child2.classList.remove(styles.small)
            } else {
              child1 && child1.classList.add(styles.big)
              child1 && child1.classList.remove(styles.small)
              child2 && child2.classList.add(styles.small)
              child2 && child2.classList.remove(styles.big)
            }
          }
          const nodeIndex = currentViewRectIndexList.findIndex((i) => i === index)
          const middleIndex = (LOOP_SLIDERS - 1) / 2
          if (nodeIndex < middleIndex) {
            child1 && child1.classList.remove(styles.right)
            child1 && child1.classList.add(styles.left)
            child2 && child2.classList.remove(styles.right)
            child2 && child2.classList.add(styles.left)
          } else if (nodeIndex > middleIndex) {
            child1 && child1.classList.remove(styles.left)
            child1 && child1.classList.add(styles.right)
            child2 && child2.classList.remove(styles.left)
            child2 && child2.classList.add(styles.right)
          }
        } else {
          child1 && child1.classList.remove(styles.small)
          child1 && child1.classList.remove(styles.big)
          child2 && child2.classList.remove(styles.small)
          child2 && child2.classList.remove(styles.big)
        }
      })
  }

  const swiperConfig: SwiperOptions = {
    slidesPerView: LOOP_SLIDERS,
    spaceBetween: 0,
    speed: ITEM_TRANSITION_TIMING,
    preventClicks: false,
    preventClicksPropagation: false,
    loop: true,
    autoplay: {
      waitForTransition: true,
      delay: ITEM_SCROLL_TIME,
      disableOnInteraction: false,
    },
  }

  return (
    <div className={styles.twolineWrapper}>
      <Swiper {...swiperConfig} onSlideChangeTransitionStart={initStyle}>
        {groups.map((group, index) => {
          return (
            <SwiperSlide className={styles.slider} key={index}>
              {group.map((item, i) => {
                return (
                  <ProductItem
                    {...item}
                    CName={CName}
                    uid={uid}
                    pageId={pageId}
                    needScene={needScene}
                    key={i}
                    outputBusiness={outputBusiness}
                  />
                )
              })}
            </SwiperSlide>
          )
        })}
      </Swiper>
    </div>
  )
}

export default ProductTwoLine
